import { useTranslation } from 'react-i18next';
import { StatusTag } from '@monecolier/ui';
import { CARD_TONE_BY_STATUS, type CardStatus } from '../lib/enrollmentCardStatus';

// UX-38 — EXTRAIT du switch de `Home.tsx#EnrollmentCard` (comportement
// STRICTEMENT INCHANGÉ, refactor pur), réutilisé par `Inscriptions.tsx`
// (`ChildCard`) plutôt que dupliqué — même précédent que
// `lib/enrollmentCardStatus.ts`.
interface EnrollmentStatusBadgeProps {
  status: CardStatus;
}

// ⚠️ UX-40 — le TON n'est plus codé en dur ici : il vient TOUJOURS de
// `CARD_TONE_BY_STATUS` (voir la règle sémantique documentée dans
// `lib/enrollmentCardStatus.ts`), la seule source de vérité partagée avec la
// bordure d'accent de la carte et l'avatar à initiales. Ce composant ne décide
// plus que du TEXTE affiché — jamais de la couleur, jamais indépendamment des
// deux autres.
export function EnrollmentStatusBadge({ status }: EnrollmentStatusBadgeProps) {
  const { t } = useTranslation();
  const tone = CARD_TONE_BY_STATUS[status.kind];
  if (status.kind === 'rejected') return <StatusTag tone={tone}>{t('enrollmentStatusBadge.rejected')}</StatusTag>;
  if (status.kind === 'cancelled') return <StatusTag tone={tone}>{t('enrollmentStatusBadge.cancelled')}</StatusTag>;
  if (status.kind === 'reenrollmentPendingPayment') {
    return <StatusTag tone={tone}>{t('enrollmentStatusBadge.reenrollmentPendingPayment')}</StatusTag>;
  }
  if (status.kind === 'waitlisted') {
    return (
      <StatusTag tone={tone}>
        {status.position
          ? t('enrollmentStatusBadge.waitlistedWithPosition', { position: status.position })
          : t('enrollmentStatusBadge.waitlisted')}
      </StatusTag>
    );
  }
  if (status.kind === 'documentsMissing') return <StatusTag tone={tone}>{t('enrollmentStatusBadge.documentsMissing')}</StatusTag>;
  // ENR-22 — même convention de libellé que `reenrollmentPendingPayment`
  // ("Réinscription — paiement requis") : la facture d'inscription (ENR-01)
  // est due, avant même toute décision de l'école.
  if (status.kind === 'pendingPaymentRequired') {
    return <StatusTag tone={tone}>{t('enrollmentStatusBadge.pendingPaymentRequired')}</StatusTag>;
  }
  if (status.kind === 'pending') return <StatusTag tone={tone}>{t('enrollmentStatusBadge.pending')}</StatusTag>;
  if (status.kind === 'paymentPending') return <StatusTag tone={tone}>{t('enrollmentStatusBadge.paymentPending')}</StatusTag>;
  if (status.kind === 'enrolledUnknownBalance' || status.kind === 'enrolled') {
    return <StatusTag tone={tone}>{t('enrollmentStatusBadge.enrolled')}</StatusTag>;
  }
  return <StatusTag tone={tone}>{t('enrollmentStatusBadge.loading')}</StatusTag>;
}
